import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { times } from 'lodash';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Unstable_Grid2 as Grid,
} from '@mui/material';

import { ContentEmailValues } from 'features/admin/types';

import ContentRow from './ContentRow';
import Tip from 'components/Tip';

const POSITIONS = 10;

const Content: FC = () => {
  const { t } = useTranslation();
  const { errors, touched } = useFormikContext<ContentEmailValues>();
  const error = getError();

  function getError() {
    const specsTouched = touched.content_specs;
    const specsError = errors.content_specs;

    if (Array.isArray(specsError)) {
      return null;
    }

    const hasError = !!specsTouched && !!specsError;
    return hasError ? specsError : null;
  }

  return (
    <Grid container>
      <Grid xs={3}>
        <Typography variant="subtitle2">{t('common:content')}</Typography>
      </Grid>
      <Grid xs={9}>
        {!!error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        <Table>
          <TableHead>
            <TableRow sx={{ borderBottomColor: 'transparent' }}>
              <TableCell style={{ width: 50 }}>{t('common:position')}</TableCell>
              <TableCell style={{ width: 150 }}>{t('common:type')}</TableCell>
              <TableCell colSpan={2}>{t('common:source')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {times(POSITIONS, index => (
              <ContentRow key={index} index={index} />
            ))}
          </TableBody>
        </Table>
        <Tip i18nKey="contentEmails:contentTip" />
      </Grid>
    </Grid>
  );
};

export default Content;
